<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="120px">
					<el-form-item label="文章标题/副标题"><el-input v-model="queryParams.keyword" :clearable="true" placeholder="请输入文章标题/副标题"></el-input></el-form-item>
					<el-form-item label="状态" label-width="60px">
						<el-select v-model="queryParams.state" placeholder="请选择状态">
							<el-option label="全部状态" value=""></el-option>
							<el-option label="已发布" :value="1"></el-option>
							<el-option label="草稿箱" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="title" label="文章标题"></el-table-column>
					<el-table-column prop="subTitle" label="副标题"></el-table-column>
					<el-table-column prop="url" label="缩略图">
						<template slot-scope="scope">
							<el-image style="width: 50px; height: 50px" :src="scope.row.url" fit="fit" :preview-src-list="[scope.row.url]"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="isTop" label="是否置顶">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.topSw" @change="statusSwChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="state" label="状态">
						<template slot-scope="scope">
							{{scope.row.state|formatState}}
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="180">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="文章标题" prop="title"><el-input type="text" v-model="addOrUpdateForm.title" placeholder="请输入标题"></el-input></el-form-item>
				<el-form-item label="文章副标题" prop="subTitle"><el-input type="text" placeholder="请输入副标题" v-model="addOrUpdateForm.subTitle"></el-input></el-form-item>
				<el-form-item label="文章内容" prop="content">
					<quill-editor ref="myQuillEditor" v-model="addOrUpdateForm.content" :options="editorOption">
					</quill-editor>
					<el-upload class="avatar-uploader" style="height:0px;overflow: hidden;" action="/api/system/file/upload" :headers="headers" :show-file-list="false" :on-success="uploadSuccess"
						:on-error="uploadError" :before-upload="beforeUpload" accept="image/jpeg,image/png">
					</el-upload>
				</el-form-item>
				<el-form-item label="文章缩略图" prop="url">
					<el-upload class="avatar-uploader" drag action="/api/system/file/upload" :multiple="false" :headers="headers" :show-file-list="false"
						:on-success="handleUploadSuccess">
						<img v-if="addOrUpdateForm.url" :src="addOrUpdateForm.url" style="width:100%" class="avatar">
						<div v-else>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						</div>
					</el-upload>
					<div style="color:red;margin-top:-15px">图片大小不能超过2M、比例2:1</div>
				</el-form-item>
				<el-form-item label="文章作者" prop="userName"><el-input type="text" v-model="addOrUpdateForm.userName"></el-input></el-form-item>
				<el-form-item label="文章排序" prop="orderBy">
					<el-input-number v-model="addOrUpdateForm.orderBy"  :precision="0" label="请输入文章排序"></el-input-number>
				</el-form-item>
				<el-form-item label="是否置顶" prop="isTop" v-if="addOrUpdateForm.id ==null">
					<el-radio-group v-model="addOrUpdateForm.isTop">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleSave(2)">存草稿</el-button>
				<el-button size="small" type="primary" @click="handleSave(1)">立即发布</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor'
	import {
		container,
		ImageExtend
	} from 'quill-image-extend-module'

	Quill.register('modules/ImageExtend', ImageExtend)

	// require styles 引入样式
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	import ImageResize from 'quill-image-resize-module';
	Quill.register('modules/imageResize', ImageResize)
	import {
		ImageDrop
	} from '@/components/libs/ImageDrop.js';
	Quill.register('modules/imageDrop', ImageDrop)

	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction
		[{
			'size': ['small', false, 'large', 'huge']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],
		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image'],
		['clean']
	]

	import axios from 'axios'


	export default {
		extends: BaseSearch,
		components: {
			quillEditor
		},
		data() {
			return {
				url: 'mngr/institution/information',
				name: '图文',
				rules: {
					title: [{
							required: true,
							message: '请输入文章标题',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					subTitle: [{
							required: true,
							message: '请输入文章副标题',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					content: [{
							required: true,
							message: '请输入文章内容',
							trigger: 'blur'
						}
					],
					userName: [{
							required: true,
							message: '请输入文章作者',
							trigger: 'blur'
						}
					],
					url: [{
							required: true,
							message: '请选择缩略图',
							trigger: 'blur'
						}
					],
					orderBy: [{
							required: true,
							message: '请输入排序字段',
							trigger: 'blur'
						}
					],
					isTop: [{
							required: true,
							message: '请输入是否置顶',
							trigger: 'blur'
						}
					],
					state: [{
							required: true,
							message: '请输入状态',
							trigger: 'blur'
						}
					],
				},
				editorOption: {
					placeholder: '',
					theme: 'snow',
					modules: {
						imageDrop: {
							that: this,
							fileUrl: axios.defaults.fileURL
						},
						imageResize: {},
						toolbar: {
							container: container,
							handlers: {
								'image': function(value) {
									if (value) {
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								}
							}
						}
					}
				},
				quillUpdateImg: false,
				checked: false, // el-checkbox 是否勾选上
				indeterminate: false, // el-checkbox 的 indeterminate 属性为true时用以表示 checkbox 的不确定状态
				headers: {}
			};
		},
		filters: {
			formatState(state) {
				if (state == 1) {
					return '已发布'
				} else if (state == 2) {
					return '草稿箱'
				}
			}
		},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						isTop:0
					};
				}
			},
			beforeUpdate() {},
			onEditorChange({
				editor,
				html,
				text
			}) {
				console.log("---内容改变事件---")
				this.content = html
				console.log(html)
			},
			beforeUpload() {
				this.quillUpdateImg = true
			},
			fillStateSw(datas){
				if(datas){
					datas.forEach(item => {
						if (item.isTop == 1) {
							item.topSw = true
						} else {
							item.topSw = false
						}
					})
				}
			},
			statusSwChange(item) {
				if (item.topSw) {
					item.isTop = 1
					item.topSw = true
					this.updateStatusNew(1, "置顶", item.id)
				} else {
					item.isTop = 0
					item.topSw = false
					this.updateStatusNew(0, "取消置顶", item.id)
				}
			},
			uploadSuccess(response, file) {
				if (response.errorCode == '0000') {
					if (response.errorCode == '0000') {
						let quill = this.$refs.myQuillEditor.quill
						let length = quill.getSelection().index;
						quill.insertEmbed(length, 'image', response.data)
						quill.setSelection(length + 1)
					} else {
						this.$message.error('图片插入失败')
					}
					this.quillUpdateImg = false
				} else {
					this.errorMessage("系统提示", response.message);
				}

			},
			uploadError() {
				this.quillUpdateImg = false
				this.$message.error('图片插入失败')
			},
			handleUploadSuccess(res, file) {
				this.addOrUpdateForm.url = res.data;
				this.$forceUpdate();
			},
			handleSave(state){
				this.addOrUpdateForm.state=state;
				this.handleUpdate();
			}
		},
		mounted: function() {}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	/deep/ .ql-editor {
		min-height: 300px
	}
</style>


// WEBPACK FOOTER //
// src/view/front/operation/institutionInformation.vue